'use strict';

var FluxDispatcher = require('flux').Dispatcher;

module.exports.createDispatcher = function (env) {
    var Dispatcher = new FluxDispatcher();

    var _environmnet = env || 'DEV';
    var oldDispatch = Dispatcher.dispatch;
    var newDispatch = function newDispatch(action) {
        if (['LOCAL', 'DEV', 'TEST'].join(' ').indexOf(_environmnet) > -1) {
            console.log("Dispatching:", action);
        }
        return oldDispatch.call(Dispatcher, action);
    };
    Dispatcher.dispatch = newDispatch;

    /**
     * Loops through an Array of handlers and registers them with the
     * dispatcher.
     *
     * @param {Object[]} handlers
     * @param {function} logEventFn
     * @description {string} handlers[].actionType - The constant action type
     *  {function} handlers[].onSuccess - The function that gets called on success
     *  {function} handlers[].onFailure - The function that gets called on failure
     */
    Dispatcher.smartRegister = function (handlers, logEventFn) {
        var actionHandlers = {};

        handlers.forEach(function (event) {
            if (event.onSuccess) {
                actionHandlers[event.actionType + "_SUCCESS"] = event.onSuccess;
            }
            if (event.onFailure) {
                actionHandlers[event.actionType + "_FAILURE"] = event.onFailure;
            }
        });

        Dispatcher.register(function (action) {
            var handler = actionHandlers[action.actionType];

            if (handler) {
                if (!!logEventFn && typeof logEventFn === 'function') logEventFn.call(null, action);

                handler(action);
            }
        });
    };

    return Dispatcher;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/lib/flux/dispatcher.js
// module id = 782
// module chunks = 0